module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "autocomplete"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.search]
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-group",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "z-index": "9999999"
    }
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.choose(suggestion)
        }
      }
    }, [(_vm.sourcetype === 'INTERNAL') ? _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(suggestion.name))]) : _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(suggestion.nama))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79a240ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/Autocomplete.vue
// module id = 1372
// module chunks = 0